<template>
  <div class="distribution-card" :class="!isPdf && 'mf-card'">
    <div v-if="!isPdf" class="distribution-card-header">
      <h2>{{ title }}</h2>
      <mf-button
        v-if="showRedirectButton"
        :label="openNewTabLabel"
        :disabled="disabled"
        text
        color="marca-0-l40"
        icon="open_in_new"
        icon-position="right"
        @click="redirect"
      />
    </div>
    <div class="distribution-content">
      <slot name="distribution-content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DistributionCard',
  props: {
    title: {
      type: String,
      default: '',
    },
    openNewTabLabel: {
      type: String,
      default: '',
    },
    openNewTabRoute: {
      type: String,
      default: '/',
    },
    showRedirectButton: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isPdf: {
      type: Boolean,
      default: false,
    },
    customRedirect: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    redirect() {
      if (this.customRedirect) {
        this.$emit('redirect')
        return
      }
      const routeURL = this.$router.resolve({ path: this.openNewTabRoute }).href
      window.open(routeURL, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.distribution-card {
  padding: 20px 20px 40px 20px;
  width: 100%;
  height: 100% !important;
  display: flex;
  flex-direction: column;
  .distribution-card-header {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-between;
    h2 {
      color: $cinza-d10;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
    }
    .v-btn {
      padding: 0 !important;
    }
  }
}

.distribution-content {
  flex: 1;
  height: 100%;
}
</style>
